import { render, staticRenderFns } from "./MyMessage.vue?vue&type=template&id=a6f1fb1e&scoped=true&"
import script from "./MyMessage.vue?vue&type=script&lang=ts&"
export * from "./MyMessage.vue?vue&type=script&lang=ts&"
import style0 from "./MyMessage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MyMessage.vue?vue&type=style&index=1&id=a6f1fb1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f1fb1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zfh/dev/targus-micor/targus-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6f1fb1e')) {
      api.createRecord('a6f1fb1e', component.options)
    } else {
      api.reload('a6f1fb1e', component.options)
    }
    module.hot.accept("./MyMessage.vue?vue&type=template&id=a6f1fb1e&scoped=true&", function () {
      api.rerender('a6f1fb1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MyMessage.vue"
export default component.exports